import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-trash",
  "use": "icon-trash-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-trash\">\n    <path d=\"M768 102.4l-51.2-102.4H307.2L256 102.4H51.2v102.4h51.2v819.2h819.2V204.8h51.2V102.4zM409.6 716.8H307.2V307.2h102.4z m307.2 0h-102.4V307.2h102.4z\" fill=\"#000000\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol